// utils/groupRequestsByPageSizeAndSiteManagerZone.js

const normalizeStationName = (value) => String(value ?? '').trim().toUpperCase();

export function groupRequestsByPageSizeAndSiteManagerZone(requests) {
    if (!Array.isArray(requests)) {
      console.error('Expected requests to be an array, but received:', requests);
      return {}; // Return an empty object or handle it based on your requirement
    }
  
    // Use reduce to group data by unique combinations of pageSize and siteManagerZone
    const requestGroups = requests.reduce((acc, curr) => {
      const normalizedStation = normalizeStationName(curr.siteManagerZone);

      // Create a unique key for each combination of pageSize and siteManagerZone
      const key = `${normalizedStation}_${curr.pageSize}_${curr.linguisticRegime}_${curr.orientation}`;
  
      // If the key doesn't exist in the accumulator, initialize it with an empty array
      if (!acc[key]) {
        acc[key] = [];
      }
  
      // Push the current object into the corresponding group
      acc[key].push({
        ...curr,
        siteManagerZone: normalizedStation,
      });
  
      return acc;
    }, {});
  
    // Return request groups sorted by label3 -> label2 -> label1
  return Object.fromEntries(
  Object.entries(requestGroups).map(([key, requests]) => [
    key,
    requests.sort((a, b) =>
      ((a.label3 ?? '').toString()).localeCompare((b.label3 ?? '').toString()) ||
      ((a.label2 ?? '').toString()).localeCompare((b.label2 ?? '').toString()) ||
      ((a.label1 ?? '').toString()).localeCompare((b.label1 ?? '').toString())
    ),
  ])
);

  }
  
  export function getUniqueSiteManagerZones(requests) {
    if (!Array.isArray(requests)) {
      console.error('Expected requests to be an array, but received:', requests);
      return []; // Return an empty array if the input is not valid
    }
  
    // Use a Set to store unique siteManagerZone values
    const uniqueSiteManagerZones = new Set(
      requests
        .map((request) => normalizeStationName(request.siteManagerZone))
        .filter(Boolean)
    );
  
    // Convert the Set back into an array and return it
    return [...uniqueSiteManagerZones];
  }
  